import { AnyAction } from "redux";

const initialState = {
    leads: [],
    leadDetails: null,
    caseOrientation: null,
    isLoading: false,
    error: null,
  };
  
  export const pipelineReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
      case 'FETCH_LEADS_REQUEST':
        return { ...state, isLoading: true, error: null };
      case 'FETCH_LEADS_SUCCESS':
        return { ...state, isLoading: false, leads: action.payload };
      case 'FETCH_LEADS_FAILURE':
        return { ...state, isLoading: false, error: action.error };
      case 'FETCH_LEAD_DETAILS_SUCCESS':
        return { ...state, leadDetails: action.payload };
      case 'FETCH_CASE_ORIENTATION_SUCCESS':
        return { ...state, caseOrientation: action.payload };
      case 'SUBMIT_OFFER_FAILURE':
        return { ...state, error: action.error };
      default:
        return state;
    }
  };